import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

export const getVehicleDetailsById = async (id) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.get(`${endpoint}/vehicle-registration/${id}`, config);
        return response.data;
    } catch (error) {
        console.error('Error fetching registration:', error);
        throw error;
    }
};

export const updateVehicleDetailsRegistration = async (registrationId, formData) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.put(`${endpoint}/vehicle-registration/${registrationId}`, formData , config);
        return response.data;
    } catch (error) {
        console.error('Error updating registration:', error);
        throw error;
    }
};



// In your VehicleDetailsService.js
export const verifyVehicleDetails = async (registrationId, status) => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + user.token,
        },
    };
    try {
        const response = await axios.put(
            `${endpoint}/vehicle-registration/${registrationId}?status=${status}`, 
            {},
            config
        );
        return response.data;
    } catch (error) {
        console.error('Error updating registration:', error);
        throw error;
    }
};
